
import { Link, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useAuth } from "@/context/useAuth";
import { Layers, GitBranch, Activity, Shield, ArrowRight, Zap, CreditCard, Smartphone, Wallet, Calendar, RefreshCw, FileText, Users, Share2, TrendingUp, Network, LayoutDashboard, Webhook, Sparkles, ShoppingCart, Bitcoin, Video, Code2, Blocks, Plug, Settings, Github, Twitter } from "lucide-react";


<div id="top"></div>




export default function Home() {
  const navigate = useNavigate();
  const { user } = useAuth();


  return (
    <div className="w-full mt-0">

{/* hero section */}

<section className="relative pt-16 pb-28 overflow-hidden">

  {/* Full background */}
  <div
  className="absolute inset-0 bg-cover bg-no-repeat z-0"
  style={{
    backgroundImage: "url('/herobackground1.png')",
    backgroundPosition: "center -50px",
  }}
/>


  {/* Content */}
  <div className="max-w-7xl mx-auto px-6 md:px-20 relative z-10">
    <div className="grid lg:grid-cols-2 gap-12 items-center pt-16">
{/* repositioning text block */}
<div className="mt-12 transform translate-x-[-40px] translate-y-[-10px]"> 

      {/* Left side */}
      <div className="mt-12">
       

<h1 className="tracking-tight leading-[1.1] mb-6 text-slate-900">
  <div className="flex items-baseline">
    <span className="text-4xl lg:text-5xl mr-2 font-semibold">The</span>
    <span className="text-5xl lg:text-7xl font-bold bg-gradient-to-r from-purple-700 to-red-400 bg-clip-text text-transparent whitespace-nowrap pb-3">
      Smartest Way
    </span>
  </div>

  <div className="text-4xl lg:text-5xl whitespace-nowrap font-semibold">
    <div className="text-4xl lg:text-5xl text-slate-900 mt-1 font-semibold">
      to{" "}
      <span className="relative inline-block">
        Orchestrate Payments
        <span className="absolute left-0 -bottom-1 w-full h-[2px] bg-gradient-to-r from-purple-600 to-pink-500"></span>
      </span>
    </div>
  </div>
</h1>
<p className="text-lg text-slate-700 max-w-xl mb-8">
  Route, monitor, and optimize transactions across all your gateways — with one unified platform.
</p>

</div>
        <button
          onClick={() =>
            !user ? navigate("/auth") : navigate("/projects/create")
          }
          className="
            bg-blue-600 hover:bg-blue-700 text-white 
            rounded-xl px-8 py-4 text-lg 
            shadow-lg hover:shadow-xl 
            transition-all font-semibold
          "
        >
          Get Started
        </button>
      </div>

      {/* Right illustration */}
      <div className="relative flex justify-center mt-6 translate-y-15">
  <img
    src="/herobackground2.png"
    alt="Payment Services Illustration"
    className="w-[140%] max-w-none h-auto translate-x-23"
  />
</div>




    </div>
  </div>
</section>


{/* product platform intro */}
<section
  id="product-platform"
  className="py-24 px-6 bg-gradient-to-br from-purple-50/30 via-pink-50/20 to-blue-50/30"
>
  <div className="max-w-[1366px] mx-auto">
    <div className="grid lg:grid-cols-2 gap-16 items-center">

      {/* Left: Text */}
      <div className="max-w-[480px]">
        <h2 className="text-5xl lg:text-6xl font-bold text-slate-900 mb-6 leading-tight">
          A unified payment layer for all your gateways
        </h2>
        <p className="text-lg text-slate-600 leading-relaxed">
          One dashboard to route, monitor, and report payments across multiple providers — with no code changes. Unify your financial rails with real-time visibility and developer-friendly APIs.
        </p>
      </div>

      {/* Right: Graphic Grid */}
      <div className="relative">
        <div className="grid grid-cols-2 gap-4">

          <div className="bg-gradient-to-br from-blue-50 to-blue-100 p-8 rounded-2xl flex flex-col items-center justify-center text-center h-40">
            <Layers className="w-10 h-10 text-blue-600 mb-3" />
            <p className="text-sm font-semibold text-slate-700">Multi-Gateway</p>
          </div>

          <div className="bg-gradient-to-br from-indigo-50 to-indigo-100 p-8 rounded-2xl flex flex-col items-center justify-center text-center h-40">
            <GitBranch className="w-10 h-10 text-indigo-600 mb-3" />
            <p className="text-sm font-semibold text-slate-700">Smart Routing</p>
          </div>

          <div className="bg-gradient-to-br from-violet-50 to-violet-100 p-8 rounded-2xl flex flex-col items-center justify-center text-center h-40">
            <Activity className="w-10 h-10 text-violet-600 mb-3" />
            <p className="text-sm font-semibold text-slate-700">Live Monitoring</p>
          </div>

          <div className="bg-gradient-to-br from-purple-50 to-purple-100 p-8 rounded-2xl flex flex-col items-center justify-center text-center h-40">
            <Shield className="w-10 h-10 text-purple-600 mb-3" />
            <p className="text-sm font-semibold text-slate-700">Secure APIs</p>
          </div>

        </div>
      </div>

    </div>
  </div>
</section>

{/* accept payment  */}
<section className="py-24 px-6 bg-white">
  <div className="max-w-[1366px] mx-auto">
    <div className="grid lg:grid-cols-2 gap-16 items-center">

      {/* Left: Text */}
      <div className="max-w-[480px]">
        <p className="text-sm font-semibold text-indigo-600 uppercase tracking-wide mb-4">
          Payments
        </p>

        <h2 className="text-5xl lg:text-6xl font-bold text-slate-900 mb-6 leading-tight">
          Accept and optimize payments, globally
        </h2>

        <p className="text-lg text-slate-600 leading-relaxed mb-8">
          Connect to leading gateways like Razorpay, Stripe, and PayU — all through one orchestration layer.
          UnifiedPay auto-routes transactions and handles failovers.
        </p>

        <button className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white rounded-full px-6 py-3 text-base font-medium group transition">
          Explore Gateway Routing
          <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
        </button>

        <p className="text-sm text-slate-500 mt-6">
          Examples: UPI, Cards, Wallets, Netbanking
        </p>
      </div>

      {/* Right: Graphic Card */}
      <div className="relative">
        <div className="bg-gradient-to-br from-blue-500 to-indigo-600 p-12 rounded-3xl shadow-2xl relative overflow-hidden">

          {/* Decorative blur circles */}
          <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full blur-2xl"></div>
          <div className="absolute bottom-0 left-0 w-40 h-40 bg-white/10 rounded-full blur-2xl"></div>

          <div className="relative z-10 space-y-6">

            <div className="flex items-center space-x-4">
              <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center backdrop-blur-sm">
                <Zap className="w-6 h-6 text-white" />
              </div>
              <div>
                <h4 className="text-white font-semibold text-lg">Instant Processing</h4>
                <p className="text-white/80 text-sm">Real-time payment confirmation</p>
              </div>
            </div>

            <div className="flex items-center space-x-4">
              <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center backdrop-blur-sm">
                <CreditCard className="w-6 h-6 text-white" />
              </div>
              <div>
                <h4 className="text-white font-semibold text-lg">All Major Cards</h4>
                <p className="text-white/80 text-sm">Visa, Mastercard, Amex & more</p>
              </div>
            </div>

            <div className="flex items-center space-x-4">
              <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center backdrop-blur-sm">
                <Smartphone className="w-6 h-6 text-white" />
              </div>
              <div>
                <h4 className="text-white font-semibold text-lg">Mobile Wallets</h4>
                <p className="text-white/80 text-sm">Apple Pay, Google Pay, Samsung Pay</p>
              </div>
            </div>

            <div className="flex items-center space-x-4">
              <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center backdrop-blur-sm">
                <Wallet className="w-6 h-6 text-white" />
              </div>
              <div>
                <h4 className="text-white font-semibold text-lg">Digital Wallets</h4>
                <p className="text-white/80 text-sm">PayPal, Venmo, and local options</p>
              </div>
            </div>

          </div>
        </div>
      </div>

    </div>
  </div>
</section>

{/* new section  */}
{/* ===== Billing & Subscriptions Section Start ===== */}
<section className="py-24 px-6 bg-gradient-to-br from-pink-50/40 via-purple-50/30 to-blue-50/20">
  <div className="max-w-[1366px] mx-auto">
    <div className="grid lg:grid-cols-2 gap-16 items-center">

      {/* Left: Text */}
      <div className="max-w-[480px]">
        <p className="text-sm font-semibold text-indigo-600 uppercase tracking-wide mb-4">
          Billing
        </p>

        <h2 className="text-5xl lg:text-6xl font-bold text-slate-900 mb-6 leading-tight">
          Capture recurring revenue
        </h2>

        <p className="text-lg text-slate-600 leading-relaxed mb-8">
          Whether you're a SaaS company or a subscription marketplace, set up scheduled billing
          with flexible retry logic and unified customer handling.
        </p>

        <button
          disabled
          className="inline-flex items-center gap-2 bg-slate-300 text-slate-500 rounded-full px-6 py-3 text-base cursor-not-allowed"
        >
          Coming Soon
          <ArrowRight className="w-4 h-4" />
        </button>

        <p className="text-sm text-slate-500 mt-6">
          Examples: Monthly plans, Dunning, Invoice Automation
        </p>
      </div>

      {/* Right: Billing Visualization */}
      <div className="relative">
        <div className="bg-gradient-to-br from-violet-50 to-purple-100 p-10 rounded-3xl border border-violet-200">

          <div className="space-y-4">
            <div className="flex items-center justify-between mb-6">
              <h3 className="font-semibold text-slate-700">Recurring Billing</h3>
              <Calendar className="w-5 h-5 text-violet-600" />
            </div>

            <div className="bg-white rounded-xl p-4 flex items-center space-x-4 shadow-sm">
              <div className="w-10 h-10 bg-gradient-to-br from-violet-400 to-purple-500 rounded-lg flex items-center justify-center">
                <FileText className="w-5 h-5 text-white" />
              </div>
              <div className="flex-1">
                <p className="text-sm font-semibold text-slate-800">Monthly Plan</p>
                <p className="text-xs text-slate-500">Auto-renews on 1st</p>
              </div>
              <span className="text-sm font-bold text-slate-900">$99</span>
            </div>

            <div className="bg-white rounded-xl p-4 flex items-center space-x-4 shadow-sm">
              <div className="w-10 h-10 bg-gradient-to-br from-indigo-400 to-violet-500 rounded-lg flex items-center justify-center">
                <RefreshCw className="w-5 h-5 text-white" />
              </div>
              <div className="flex-1">
                <p className="text-sm font-semibold text-slate-800">Retry Logic</p>
                <p className="text-xs text-slate-500">Smart dunning enabled</p>
              </div>
              <span className="text-xs font-medium text-violet-600">Active</span>
            </div>

            <div className="bg-white rounded-xl p-4 flex items-center space-x-4 shadow-sm opacity-60">
              <div className="w-10 h-10 bg-gradient-to-br from-blue-400 to-indigo-500 rounded-lg flex items-center justify-center">
                <Calendar className="w-5 h-5 text-white" />
              </div>
              <div className="flex-1">
                <p className="text-sm font-semibold text-slate-800">Annual Plan</p>
                <p className="text-xs text-slate-500">Save 20%</p>
              </div>
              <span className="text-sm font-bold text-slate-900">$950</span>
            </div>

          </div>
        </div>
      </div>

    </div>
  </div>
</section>
{/* ===== Billing & Subscriptions Section End ===== */}


{/* ===== Multi-Party Splits / Connect Section Start ===== */}
<section className="py-24 px-6 bg-white">
  <div className="max-w-[1366px] mx-auto">
    <div className="grid lg:grid-cols-2 gap-16 items-center">

      {/* Left: Text */}
      <div className="max-w-[480px]">
        <p className="text-sm font-semibold text-indigo-600 uppercase tracking-wide mb-4">
          Connect
        </p>

        <h2 className="text-5xl lg:text-6xl font-bold text-slate-900 mb-6 leading-tight">
          Set up multi-party payments and payouts
        </h2>

        <p className="text-lg text-slate-600 leading-relaxed mb-8">
          Manage vendor commissions, third-party routing, and partner payouts — all configured at project level.
          Use webhook-based control or our visual UI.
        </p>

        <button className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white rounded-full px-6 py-3 text-base font-medium group transition">
          Read About Connect
          <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
        </button>

        <p className="text-sm text-slate-500 mt-6">
          Examples: Marketplaces, Aggregators, Affiliate Systems
        </p>
      </div>

      {/* Right: Network Graphic */}
      <div className="relative">

        {/* Central Node */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-24 h-24 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-2xl shadow-xl flex items-center justify-center z-10">
          <Share2 className="w-10 h-10 text-white" />
        </div>

        {/* Connecting Lines */}
        <svg className="absolute inset-0 w-full h-full" style={{ zIndex: 1 }}>
          <line x1="50%" y1="50%" x2="20%" y2="20%" stroke="#cbd5e1" strokeWidth="2" strokeDasharray="4 4" />
          <line x1="50%" y1="50%" x2="80%" y2="20%" stroke="#cbd5e1" strokeWidth="2" strokeDasharray="4 4" />
          <line x1="50%" y1="50%" x2="20%" y2="80%" stroke="#cbd5e1" strokeWidth="2" strokeDasharray="4 4" />
          <line x1="50%" y1="50%" x2="80%" y2="80%" stroke="#cbd5e1" strokeWidth="2" strokeDasharray="4 4" />
        </svg>

        {/* Satellite Nodes */}
        <div className="absolute top-0 left-0 w-20 h-20 bg-white border-2 border-blue-200 rounded-xl shadow-lg flex flex-col items-center justify-center">
          <Users className="w-6 h-6 text-blue-600 mb-1" />
          <span className="text-xs font-medium text-slate-700">Vendor A</span>
        </div>

        <div className="absolute top-0 right-0 w-20 h-20 bg-white border-2 border-indigo-200 rounded-xl shadow-lg flex flex-col items-center justify-center">
          <Users className="w-6 h-6 text-indigo-600 mb-1" />
          <span className="text-xs font-medium text-slate-700">Vendor B</span>
        </div>

        <div className="absolute bottom-0 left-0 w-20 h-20 bg-white border-2 border-violet-200 rounded-xl shadow-lg flex flex-col items-center justify-center">
          <TrendingUp className="w-6 h-6 text-violet-600 mb-1" />
          <span className="text-xs font-medium text-slate-700">Affiliate</span>
        </div>

        <div className="absolute bottom-0 right-0 w-20 h-20 bg-white border-2 border-purple-200 rounded-xl shadow-lg flex flex-col items-center justify-center">
          <Share2 className="w-6 h-6 text-purple-600 mb-1" />
          <span className="text-xs font-medium text-slate-700">Partner</span>
        </div>

        {/* Spacer for Layout */}
        <div className="w-full h-80"></div>

      </div>

    </div>
  </div>
</section>
{/* ===== Multi-Party Splits / Connect Section End ===== */}

{/* ===== Orchestration Features Section Start ===== */}
<section id="features" className="py-24 px-6 bg-gradient-to-br from-orange-900 via-purple-900 to-indigo-950">
  <div className="max-w-7xl mx-auto">

    {/* Heading */}
    <div className="text-center mb-16">
      <h2 className="text-4xl lg:text-5xl font-bold text-white mb-4">
        Everything You Need to Orchestrate Payments
      </h2>
      <p className="text-xl text-white/90 max-w-3xl mx-auto">
        Built for developers, designed for scale. UnifiedPay brings all your payment operations together.
      </p>
    </div>

    {/* Feature Cards */}
    <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
      {[
        {
          icon: Network,
          title: "Multi-Gateway Routing",
          desc: "Seamlessly route transactions across multiple payment gateways with intelligent fallback mechanisms.",
          gradient: "from-blue-500 to-blue-600",
        },
        {
          icon: Activity,
          title: "Live Gateway Monitoring",
          desc: "Monitor gateway health and performance in real-time with instant alerts and detailed analytics.",
          gradient: "from-cyan-500 to-cyan-600",
        },
        {
          icon: LayoutDashboard,
          title: "Unified Dashboard",
          desc: "Manage all your projects, gateways, and transactions from a single, powerful dashboard.",
          gradient: "from-indigo-500 to-indigo-600",
        },
        {
          icon: Webhook,
          title: "API & Webhook Control",
          desc: "Developer-ready APIs and webhooks with comprehensive documentation and real-time event tracking.",
          gradient: "from-purple-500 to-purple-600",
        },
      ].map((item, i) => {
        const Icon = item.icon;
        return (
          <div
            key={i}
            className="p-6 h-full bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl hover:shadow-xl transition-shadow"
          >
            <div className={`w-14 h-14 rounded-xl bg-gradient-to-br ${item.gradient} flex items-center justify-center mb-4`}>
              <Icon className="w-7 h-7 text-white" />
            </div>
            <h3 className="text-xl font-semibold text-white mb-2">
              {item.title}
            </h3>
            <p className="text-white/80 leading-relaxed">
              {item.desc}
            </p>
          </div>
        );
      })}
    </div>

    {/* Stats */}
    <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mt-16 pt-16 border-t border-white/20">
      {[
        { value: "100+", label: "Merchants Onboarded" },
        { value: "99.9%", label: "Uptime Guarantee" },
        { value: "10+", label: "Gateway Integrations" },
        { value: "<100ms", label: "Average Response Time" },
      ].map((stat, i) => (
        <div key={i} className="text-center">
          <div className="text-4xl font-bold text-white mb-2">{stat.value}</div>
          <div className="text-white/80">{stat.label}</div>
        </div>
      ))}
    </div>

  </div>
</section>
{/* ===== Orchestration Features Section End ===== */}
{/* ===== Use Cases Section Start ===== */}
<section id="use-cases" className="py-24 px-6 bg-white">
  <div className="max-w-7xl mx-auto">

    <div className="text-center mb-12">
      <h2 className="text-4xl font-bold text-slate-900 mb-4">
        Built for Any Business Type
      </h2>
      <p className="text-xl text-slate-600 max-w-2xl mx-auto">
        Whether you're building AI products, SaaS platforms, or marketplaces, UnifiedPay scales with you
      </p>
    </div>

    <div className="overflow-x-auto pb-4 -mx-4 px-4 sm:mx-0 sm:px-0">
      <div className="flex sm:grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 min-w-max sm:min-w-0">

        {[
          { icon: Sparkles, title: "AI", desc: "Real-time payments for usage-based models", logos: ["OpenAI", "Anthropic", "Midjourney", "Hugging Face"], gradient: "from-purple-500 to-pink-500" },
          { icon: RefreshCw, title: "SaaS", desc: "Recurring billing, subscription insights, unified dashboard", logos: ["Freshworks", "Zoho", "Postman", "Clevertap"], gradient: "from-blue-500 to-cyan-500" },
          { icon: Users, title: "Marketplace", desc: "Route, split, and reconcile multi-party payments easily", logos: ["Zomato", "Swiggy", "Urban Company", "Meesho"], gradient: "from-orange-500 to-red-500" },
          { icon: CreditCard, title: "Embedded finance", desc: "Commercial cards and lending in-product", logos: ["Ramp", "Shopify", "Persona"], gradient: "from-violet-500 to-purple-500" },
          { icon: ShoppingCart, title: "E-commerce", desc: "Optimised global checkout and in-person payments", logos: ["Glossier", "Dermalogica", "INDOCHINO"], gradient: "from-blue-600 to-blue-700" },
          { icon: Bitcoin, title: "Crypto", desc: "Embed crypto purchases with fraud prevention", logos: ["Blockchain.com", "Braintrust", "Magic"], gradient: "from-cyan-500 to-teal-500" },
          { icon: Video, title: "Creator economy", desc: "Global payouts for creators with prebuilt UI", logos: ["X", "Spotify", "Substack"], gradient: "from-indigo-500 to-blue-500" },
        ].map((item, i) => {
          const Icon = item.icon;
          return (
            <div key={i} className="w-80 sm:w-auto p-6 bg-white border border-slate-200 rounded-2xl hover:shadow-xl transition-shadow">

              <div className={`w-12 h-12 rounded-xl bg-gradient-to-br ${item.gradient} flex items-center justify-center mb-4`}>
                <Icon className="w-6 h-6 text-white" />
              </div>

              <h3 className="text-2xl font-bold text-slate-900 mb-3">
                {item.title}
              </h3>

              <p className="text-slate-600 mb-6">
                {item.desc}
              </p>

              <div className="pt-4 border-t border-slate-200">
                <p className="text-xs text-slate-500 mb-3 uppercase tracking-wide">
                  Trusted by
                </p>
                <div className="flex flex-wrap gap-2">
                  {item.logos.map((logo) => (
                    <span key={logo} className="px-3 py-1.5 bg-slate-100 text-slate-700 rounded-lg text-sm font-medium">
                      {logo}
                    </span>
                  ))}
                </div>
              </div>

            </div>
          );
        })}

      </div>
    </div>
  </div>
</section>
{/* ===== Use Cases Section End ===== */}
{/* ===== Developer Platform Section Start ===== */}
<section id="developer-section" className="py-24 px-6 bg-white">
  <div className="max-w-7xl mx-auto">

    <div className="text-center mb-12">
      <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mb-4">
        Everything You Need to Orchestrate Payments
      </h2>
      <p className="text-xl text-slate-600 max-w-2xl mx-auto mb-4">
        Built for Developers by Developers
      </p>
      <p className="text-lg text-slate-600 max-w-2xl mx-auto">
        Ship payment integrations in hours, not weeks. Our SDK handles the complexity so you can focus on building.
      </p>
    </div>

    <div className="grid lg:grid-cols-2 gap-12 items-start mb-12">

      {/* Left: Description */}
      <div className="space-y-6">
        <h3 className="text-3xl font-bold text-slate-900">
          One API. Multiple Gateways. Infinite Possibilities.
        </h3>

        <p className="text-lg text-slate-600">
          Integrate once, route intelligently across payment providers. Our developer-first SDK provides complete control with minimal code.
        </p>

        <div className="space-y-4">
          {[
            "Simple Integration",
            "Smart Routing",
            "Real-time Monitoring"
          ].map((title, i) => (
            <div key={i} className="flex items-start space-x-3">
              <div className="w-6 h-6 rounded-full bg-blue-100 flex items-center justify-center mt-1">
                <div className="w-2 h-2 rounded-full bg-blue-600"></div>
              </div>
              <div>
                <p className="font-semibold text-slate-900">{title}</p>
                <p className="text-slate-600">
                  {title === "Simple Integration" && "Get started with just a few lines of code"}
                  {title === "Smart Routing" && "Automatic failover and gateway selection"}
                  {title === "Real-time Monitoring" && "Track gateway health and transaction status"}
                </p>
              </div>
            </div>
          ))}
        </div>

        <button className="bg-blue-600 hover:bg-blue-700 text-white rounded-xl px-8 py-4 text-lg shadow-lg transition">
          Read the Docs
        </button>
      </div>

      {/* Right: Code Block */}
      <div className="bg-slate-900 rounded-2xl p-6 text-slate-300 font-mono text-sm overflow-x-auto">
        <div className="flex items-center mb-4">
          <div className="flex space-x-2">
            <span className="w-3 h-3 bg-red-500 rounded-full"></span>
            <span className="w-3 h-3 bg-yellow-500 rounded-full"></span>
            <span className="w-3 h-3 bg-green-500 rounded-full"></span>
          </div>
          <span className="ml-4 text-slate-400">unifiedpay-integration.js</span>
        </div>
        <pre>
{`// Initialize UnifiedPay SDK
import UnifiedPay from '@unifiedpay/sdk';

const payment = new UnifiedPay({
  apiKey: 'your_api_key',
  mode: 'production'
});

const result = await payment.create({
  amount: 50000,
  currency: 'INR',
  strategy: 'auto',
  fallback: ['razorpay', 'payu', 'stripe']
});

payment.on('gateway.status', (event) => {
  console.log(\`Gateway \${event.name}: \${event.status}\`);
});`}
        </pre>
      </div>

    </div>

    {/* Feature Tiles */}
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
      {[
        { icon: Code2, title: "Use with your stack", desc: "React, Node, .NET, Python" },
        { icon: Webhook, title: "Webhook control + retries", desc: "Automated retry logic" },
        { icon: Blocks, title: "Build internal apps", desc: "Custom admin dashboards" },
        { icon: Plug, title: "Pre-integrated gateways", desc: "Razorpay, PayU, UnifiedPay" },
      ].map((item, i) => {
        const Icon = item.icon;
        return (
          <div key={i} className="p-6 border rounded-xl hover:shadow-lg transition">
            <Icon className="w-8 h-8 text-blue-600 mb-3" />
            <h4 className="font-bold text-slate-900 mb-2">{item.title}</h4>
            <p className="text-sm text-slate-600">{item.desc}</p>
          </div>
        );
      })}
    </div>

  </div>
</section>
{/* ===== Developer Platform Section End ===== */}
{/* ===== How It Works Section Start ===== */}
<section id="how-it-works" className="py-24 px-6 bg-[#0f2942]">
  <div className="max-w-7xl mx-auto">

    <div className="text-center mb-16">
      <h2 className="text-4xl lg:text-5xl font-bold text-white mb-4">
        How It Works
      </h2>
      <p className="text-xl text-slate-300 max-w-3xl mx-auto">
        Get started with UnifiedPay in three simple steps
      </p>
    </div>

    <div className="grid md:grid-cols-3 gap-8 relative">

      {/* Connection Line */}
      <div className="hidden md:block absolute top-20 left-0 right-0 h-0.5 bg-gradient-to-r from-blue-400/30 via-cyan-400/30 to-indigo-400/30"></div>

      {[
        {
          icon: Settings,
          title: "Add your project & configure gateways",
          desc: "Set up your project in minutes. Connect multiple payment gateways with simple API keys and start routing transactions.",
          color: "from-blue-500 to-blue-600",
        },
        {
          icon: TrendingUp,
          title: "Track real-time transactions & failures",
          desc: "Monitor every transaction as it happens. Get instant alerts on failures and automatically retry with backup gateways.",
          color: "from-cyan-500 to-cyan-600",
        },
        {
          icon: FileText,
          title: "Download reports and monitor performance",
          desc: "Generate comprehensive reports with detailed analytics. Track success rates, identify patterns, and optimize your payment flows.",
          color: "from-indigo-500 to-indigo-600",
        },
      ].map((step, i) => {
        const Icon = step.icon;
        return (
          <div key={i} className="relative flex flex-col items-center text-center">

            <div className={`relative w-20 h-20 rounded-full bg-gradient-to-br ${step.color} flex items-center justify-center mb-6 shadow-lg z-10`}>
              <Icon className="w-10 h-10 text-white" />
              <div className="absolute -top-2 -right-2 w-8 h-8 bg-white rounded-full flex items-center justify-center shadow-md">
                <span className="text-sm font-bold text-slate-900">{i + 1}</span>
              </div>
            </div>

            <h3 className="text-xl font-semibold text-white mb-3">
              {step.title}
            </h3>

            <p className="text-slate-300 leading-relaxed">
              {step.desc}
            </p>

          </div>
        );
      })}
    </div>

  </div>
</section>
{/* ===== How It Works Section End ===== */}
{/* ===== CTA Banner Section Start ===== */}
<section id="cta-banner" className="py-24 px-6 bg-gradient-to-br from-purple-600 via-blue-600 to-indigo-600">
  <div className="max-w-7xl mx-auto">
    <div className="grid lg:grid-cols-2 gap-12 items-start">

      {/* Left: Text and Buttons */}
      <div>
        <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
          Ready to get started?
        </h2>

        <p className="text-xl text-white/90 mb-8 max-w-md">
          Create an account instantly to get started or contact us to design a custom package for your business.
        </p>

        <div className="flex flex-wrap gap-4">
          <button
            onClick={() => window.location.href = "/auth"}
            className="bg-white text-blue-600 hover:bg-slate-50 rounded-lg px-6 py-3 text-base shadow-md hover:shadow-lg transition-all flex items-center gap-2"
          >
            Sign In
            <ArrowRight className="w-4 h-4" />
          </button>

          <button
            onClick={() => alert("Demo: Contact form would open here")}
            className="text-white border border-white/30 hover:bg-white/10 rounded-lg px-6 py-3 text-base flex items-center gap-2"
          >
            Contact sales
            <ArrowRight className="w-4 h-4" />
          </button>
        </div>
      </div>

      {/* Right: Info Cards */}
      <div className="grid sm:grid-cols-2 gap-6">

        <div className="space-y-3">
          <div className="w-12 h-12 rounded-lg bg-white/20 backdrop-blur-sm flex items-center justify-center">
            <svg className="w-6 h-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
          </div>

          <h3 className="font-semibold text-white">
            Always know what you pay
          </h3>

          <p className="text-sm text-white/80">
            Integrated per-transaction pricing with no hidden fees.
          </p>

          <a href="#" className="inline-flex items-center text-sm text-white hover:text-white/80 font-medium">
            Pricing details
            <ArrowRight className="ml-1 w-4 h-4" />
          </a>
        </div>

        <div className="space-y-3">
          <div className="w-12 h-12 rounded-lg bg-white/20 backdrop-blur-sm flex items-center justify-center">
            <svg className="w-6 h-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
            </svg>
          </div>

          <h3 className="font-semibold text-white">
            Start your integration
          </h3>

          <p className="text-sm text-white/80">
            Get up and running with UnifiedPay in as little as 10 minutes.
          </p>

          <a href="#" className="inline-flex items-center text-sm text-white hover:text-white/80 font-medium">
            API reference
            <ArrowRight className="ml-1 w-4 h-4" />
          </a>
        </div>

      </div>
    </div>
  </div>
</section>
{/* ===== CTA Banner Section End ===== */}
{/* ===== Footer Section Start ===== */}
<footer id="footer" className="bg-gradient-to-br from-slate-900 via-indigo-950 to-purple-950 text-slate-300 py-12 px-6">
  <div className="max-w-7xl mx-auto">

    <div className="grid md:grid-cols-4 gap-8 mb-8">

      {/* Logo & About */}
      <div className="md:col-span-2">
        <div className="flex items-center space-x-2 mb-4">
          <div className="w-10 h-10 bg-gradient-to-br from-blue-600 to-blue-800 rounded-lg flex items-center justify-center">
            <span className="text-white font-bold text-xl">U</span>
          </div>
          <span className="text-2xl font-bold text-white">UnifiedPay</span>
        </div>

        <p className="text-slate-400 mb-4 max-w-md">
          The modern payment orchestration platform that unifies all your gateways.
          Built for developers, designed for scale.
        </p>

        <div className="flex space-x-4">
          <a
            href="#"
            className="w-10 h-10 bg-slate-800 rounded-lg flex items-center justify-center hover:bg-blue-600 transition"
            aria-label="GitHub"
          >
            <Github className="w-5 h-5" />
          </a>

          <a
            href="#"
            className="w-10 h-10 bg-slate-800 rounded-lg flex items-center justify-center hover:bg-blue-600 transition"
            aria-label="Twitter"
          >
            <Twitter className="w-5 h-5" />
          </a>
        </div>
      </div>

      {/* Product */}
      <div>
        <h3 className="text-white font-semibold mb-4">Product</h3>
        <ul className="space-y-2">
          <li><a href="#features" className="hover:text-blue-400">Features</a></li>
          <li><a href="#" className="hover:text-blue-400">Integrations</a></li>
          <li><a href="#" className="hover:text-blue-400">Pricing</a></li>
          <li><a href="#" className="hover:text-blue-400">API Reference</a></li>
        </ul>
      </div>

      {/* Company */}
      <div>
        <h3 className="text-white font-semibold mb-4">Company</h3>
        <ul className="space-y-2">
          <li><a href="#" className="hover:text-blue-400">Docs</a></li>
          <li><a href="#" className="hover:text-blue-400">Contact</a></li>
          <li><a href="#" className="hover:text-blue-400">Terms of Service</a></li>
          <li><a href="#" className="hover:text-blue-400">Privacy Policy</a></li>
        </ul>
      </div>

    </div>

    {/* Bottom Bar */}
    <div className="pt-8 border-t border-slate-800 flex flex-col md:flex-row justify-between items-center gap-4">
      <p className="text-slate-400 text-sm">
        © {new Date().getFullYear()} UnifiedPay. All rights reserved.
      </p>
      <p className="text-slate-400 text-sm">
        Built with ❤️ for developers everywhere
      </p>
    </div>

  </div>
</footer>
{/* ===== Footer Section End ===== */}

    </div>
  );
}
